import { render } from "./DashboardTab.vue?vue&type=template&id=6e9c3dc3&scoped=true"
import script from "./DashboardTab.vue?vue&type=script&lang=js"
export * from "./DashboardTab.vue?vue&type=script&lang=js"

import "./DashboardTab.vue?vue&type=style&index=0&id=6e9c3dc3&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9c3dc3"]])

export default __exports__